import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _excluded = ["prefixCls", "className", "children", "style", "disabled"];
import classNames from "classnames";
import RcCheckbox from "rc-checkbox2.3";
import { composeRef } from "rc-util/lib/ref";
import * as React from "react";
import { useContext } from "react";
import { ConfigContext } from "../../ConfigProvider";
import DisabledContext from "../../ConfigProvider/DisabledContext";
import { FormItemInputContext } from "../../Form/hack/context";
import warning from "../../hack/_util/warning";
import RadioGroupContext, { RadioOptionTypeContext } from "./context";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var InternalRadio = function InternalRadio(props, ref) {
  var _classNames;
  var groupContext = React.useContext(RadioGroupContext);
  var radioOptionTypeContext = React.useContext(RadioOptionTypeContext);
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction;
  var wrapRef = React.useRef(null);
  var innerRef = React.useRef();
  var mergedRef = composeRef(innerRef);
  var _useContext = useContext(FormItemInputContext),
    isFormItemInput = _useContext.isFormItemInput;
  React.useImperativeHandle(ref, function () {
    return _objectSpread(_objectSpread({}, innerRef.current), {}, {
      wrapRef: {
        current: wrapRef.current
      }
    });
  }, []);
  warning(!("optionType" in props), "Radio", "`optionType` is only support in Radio.Group.");
  var onChange = function onChange(e) {
    var _props$onChange, _groupContext$onChang;
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, e);
    groupContext === null || groupContext === void 0 ? void 0 : (_groupContext$onChang = groupContext.onChange) === null || _groupContext$onChang === void 0 ? void 0 : _groupContext$onChang.call(groupContext, e);
  };
  var customizePrefixCls = props.prefixCls,
    className = props.className,
    children = props.children,
    style = props.style,
    customDisabled = props.disabled,
    restProps = _objectWithoutProperties(props, _excluded);
  var radioPrefixCls = getPrefixCls("radio", customizePrefixCls);
  var prefixCls = ((groupContext === null || groupContext === void 0 ? void 0 : groupContext.optionType) || radioOptionTypeContext) === "button" ? "".concat(radioPrefixCls, "-button") : radioPrefixCls;
  var radioProps = _objectSpread({}, restProps);

  // ===================== Disabled =====================
  var disabled = React.useContext(DisabledContext);
  radioProps.disabled = customDisabled || disabled;
  if (groupContext) {
    radioProps.name = groupContext.name;
    radioProps.onChange = onChange;
    radioProps.checked = props.value === groupContext.value;
    radioProps.disabled = radioProps.disabled || groupContext.disabled;
  }
  var wrapperClassString = classNames("".concat(prefixCls, "-wrapper"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-rtl"), direction === "rtl"), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-in-form-item"), isFormItemInput), _classNames), className);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _jsxs("label", {
      ref: wrapRef,
      className: wrapperClassString,
      style: style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      children: [/*#__PURE__*/_jsx(RcCheckbox, _objectSpread(_objectSpread({}, radioProps), {}, {
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef
      })), children !== undefined ? /*#__PURE__*/_jsx("span", {
        children: children
      }) : null]
    })
  );
};
// @ts-ignore
var Radio = /*#__PURE__*/React.forwardRef(InternalRadio);
// @ts-ignore
if (process.env.NODE_ENV !== "production") {
  Radio.displayName = "Radio";
}
export default Radio;